





























































































































































































































































































































import { Component, Vue, Watch, Ref } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeContratosStore from '@/components/RemuneracaoMedica/contratos/Store/BackofficeContratosStore'
import { maskDate, maskMoney } from '@/utils/common'

@Component
export default class ComponentModalAddRegras extends Vue {
  $refs!: { tableRegras: any }
  addrgsLoading: boolean = false

  get getBackofficeContratosStore() {
    return getModule(BackofficeContratosStore, this.$store)
  }

  get addRegrasLoading() {
    return this.addrgsLoading
  }

  set addRegrasLoading(value: boolean) {
    this.addrgsLoading = value
  }

  get selected() {
    return this.getBackofficeContratosStore.selectedRegras
  }

  set selected(value: any[]) {
    this.getBackofficeContratosStore.setSelectedRegras(value)
  }

  get regrasSearch() {
    return this.getBackofficeContratosStore.regrasSearch
  }

  set regrasSearch(value: string) {
    this.getBackofficeContratosStore.setRegrasSearch(value)
  }

  get addRegrasList() {
    return this.getBackofficeContratosStore.modal.addRegrasList
  }

  get regrasTableHeader() {
    return this.getBackofficeContratosStore.regrasTableHeader
  }

  get regras() {
    return this.getBackofficeContratosStore.regras
  }

  maskDateUtil(date: string) {
    return maskDate(date)
  }

  formatMoney(value: string) {
    return maskMoney(value)
  }

  displayPagamento(str: string) {
    switch (str.toLowerCase()) {
      case 'percentual':
        return 'Percentual'
      case 'valorfixo':
        return 'Fixo'
      default:
        return 'Cálculo'
    }
  }

  closeModalRegras() {
    this.closeExpanded()
    this.getBackofficeContratosStore.clearRegras()
    this.getBackofficeContratosStore.clearRegrasSearch()
    this.getBackofficeContratosStore.clearSelectedRegras()
    this.getBackofficeContratosStore.setShowModalAddRegrasList(false)
  }

  async closeExpanded() {
    await this.$nextTick(() => {
      this.$refs.tableRegras.expanded = {}
    })
  }

  async addRegras() {
    this.addRegrasLoading = true
    await this.getBackofficeContratosStore.addRegras()
    this.addRegrasLoading = false
    this.closeModalRegras()
  }
}
